// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны

export interface IMediaSchema {
  /** ID медиа **/
  id?: string;
  /** Ссылка на превью медиа **/
  previewUrl: string;
  /** Тип медиа (фото, видео, планировка) **/
  type: EType;
  /** Ссылка на медиа **/
  url: string;
  /** Конкретный тип видео (только для type='video') **/
  videoType?: EVideoType;
}

export enum EType {
  /** Планировка **/
  'Layout' = 'layout',
  /** Фото **/
  'Photo' = 'photo',
  /** Видео **/
  'Video' = 'video',
}
export enum EVideoType {
  /** Видео из Kinescope **/
  'Kinescope' = 'kinescope',
  /** Видео из Rutube **/
  'Rutube' = 'rutube',
  /** Видео из VK **/
  'Vk' = 'vk',
  /** Видео с youtube.com **/
  'Youtube' = 'youtube',
}
